<template>
    <div class="toast align-items-center text-white" :class="toastClasses" role="alert" aria-live="assertive"
        aria-atomic="true" ref="toastRef">
        <div class="d-flex">
            <div class="toast-body">{{ mensaje }}</div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="ocultar" />
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import * as bootstrap from 'bootstrap';
const props = defineProps({
    tipo: String,
    mensaje: String
});

const toastRef = ref(null);
let toastInstance = null;

const tipoClase = {
    success: "bg-success",
    danger: "bg-danger",
    error: "bg-danger",
    info: "bg-info"
};

const toastClasses = tipoClase[props.tipo] || "bg-primary";

const ocultar = () => {
    toastInstance?.hide();
};

onMounted(() => {
    // bootstrap = await import("bootstrap");
    toastInstance = new bootstrap.Toast(toastRef.value);
    toastInstance.show();
});
</script>

<style scoped>
.toast {
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    z-index: 1060;
}
</style>
